<template>
  <div :id="`${singularizeIndex(index)}-${parsedResultData.slug}`" @click="linkToResult($event)" @click.middle="redirectMiddleClick($event)" class="card-wrapper">
    <component :is="componentContentName"
      :highlights="computedHighlights"
      :highlightsLoading="!highlightsLoaded"
      :matches="matches"
      :index="index"
      :data="parsedResultData"
      class="card card-list"
      :class="classes"
      :link="getRoute"
    >
      <template #actions>
        <base-actions
          :index="index"
          :data="parsedResultData"
          :link="getRoute"
        />
      </template>
    </component>

    <div class="label-search-result">
      <span v-if="isOutOfBusiness"
        class="label-base bg-red"
        v-tooltip="'Our sources indicate this company is out of business.'"
      >CLOSED</span>
      <span v-else-if="isNew" class="label-base bg-yellow">NEW</span>
      <img
        v-if="result.data.is_open_access"
        class="ml-2"
        :src="require('@/assets/img/icon/open_access.svg')"
        style="height: 20px; width: 12.8px;">
    </div>
  </div>
</template>

<script>
import inViewport from 'vue-in-viewport-mixin'

import ResearchGroupResultList from '@/components/research_group/result/List'
import PublicationResultList from '@/components/publication/result/List'
import ResearcherResultList from '@/components/researcher/result/List'
import ProjectResultList from '@/components/project/result/List'
import PatentResultList from '@/components/patent/result/List'
import ResearchTopicResultList from '@/components/research_topic/result/List'
import ClinicalTrialResultList from '@/components/clinical_trial/result/List'
import OrganisationResultList from '@/components/organisation/result/List'
import NewsResultList from '@/components/news/result/List'
import BaseActions from '@/components/search/results/BaseActions'

import highlights from '@/mixins/highlights'
// resultHelpers is where most of the functionality of this component is located (computed properties, methods, ...)
import resultHelpers from '@/mixins/search/resultHelpers'

export default {
  name: 'searchResultBaseList',
  mixins: [inViewport, highlights, resultHelpers],
  components: {
    ResearchGroupResultList,
    PublicationResultList,
    ResearcherResultList,
    ProjectResultList,
    PatentResultList,
    ResearchTopicResultList,
    ClinicalTrialResultList,
    OrganisationResultList,
    NewsResultList,
    BaseActions
  },
  props: {
    index: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: true
    },
    inViewportOnce: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      classes: [`card-list--${this.singularizeIndex(this.index)}`]
    }
  },
  watch: {
    'inViewport.now': {
      handler (visible) {
        if (visible) {
          this.fetchHighlights()
        }
      }
    }
  },
  computed: {
    componentContentName () {
      return `${this.cleanedIndex}ResultList`
    }
  }
}
</script>
